module.exports = __webpack_public_path__ + "img/logo.764d21eb.png";